import { Box, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { houseVisitSlotEventShellStyle } from "./slot-calendar-colors";
import type { HouseVisitSlotCalendarEvent } from "./types";

const SAMPLES: Array<Pick<HouseVisitSlotCalendarEvent, "fillRatio" | "stopCount" | "capacity">> = [
  { fillRatio: 0, stopCount: 0, capacity: 10 },
  { fillRatio: 0.5, stopCount: 5, capacity: 10 },
  { fillRatio: 1, stopCount: 10, capacity: 10 },
];

const LABELS = ["Empty", "Partial", "Full"];

export function HouseVisitSlotsCalendarLegend() {
  const theme = useTheme();

  return (
    <Stack
      direction="row"
      spacing={1.5}
      alignItems="center"
      flexWrap="wrap"
      useFlexGap
      sx={{ px: 1.5, pb: 1 }}
    >
      <Typography variant="caption" color="text.secondary" sx={{ mr: 0.5 }}>
        Capacity
      </Typography>
      {SAMPLES.map((sample, i) => {
        const style = houseVisitSlotEventShellStyle(theme, {
          id: i,
          title: "",
          start: new Date(),
          end: new Date(),
          allDay: true,
          fillRatio: sample.fillRatio,
          stopCount: sample.stopCount,
          capacity: sample.capacity,
          resource: {
            id: String(i),
            eventId: "",
            date: "",
            capacity: sample.capacity,
          },
        });
        return (
          <Stack key={LABELS[i]} direction="row" spacing={0.75} alignItems="center">
            <Box
              sx={{
                width: 14,
                height: 14,
                borderRadius: 0.5,
                bgcolor: style.backgroundColor,
                border: style.border,
                flexShrink: 0,
              }}
            />
            <Typography variant="caption" color="text.secondary">
              {LABELS[i]}
            </Typography>
          </Stack>
        );
      })}
    </Stack>
  );
}
